import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutProgressComponent } from '@spartacus/checkout/base/components';

@Component({
  selector: 'cx-checkout-progress',
  templateUrl: './custom-checkout-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomCheckoutProgressComponent extends CheckoutProgressComponent {
}
